export default "__VITE_ASSET__CXq9CLRh__"